// extracted by mini-css-extract-plugin
module.exports = {"g1egyh5":"g1egyh5","o1jpq6g6":"o1jpq6g6","s1r2ig8a":"s1r2ig8a"};